import { clear } from './delete';
import { add } from './add';

export function init(stageCube: CubeNode): void {
    clear();
    stageCube.walk((cube: CubeNode): void => {
        add(cube);
    });
}
